var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.dataFetched && _vm.allowed)?_c('PlanActionComponent',{attrs:{"projet":_vm.projet}}):_vm._e(),_c('br'),_c('br'),_c('ProjetAuthorization',{attrs:{"projet_id":_vm.projet_id},on:{"isAllowed":_vm.isAllowed}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }